"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStateName = exports.StateNames = exports.USStates = void 0;
var USStates;
(function (USStates) {
    USStates["AL"] = "AL";
    USStates["AK"] = "AK";
    USStates["AZ"] = "AZ";
    USStates["AR"] = "AR";
    USStates["CA"] = "CA";
    USStates["CO"] = "CO";
    USStates["CT"] = "CT";
    USStates["DE"] = "DE";
    USStates["FL"] = "FL";
    USStates["GA"] = "GA";
    USStates["HI"] = "HI";
    USStates["ID"] = "ID";
    USStates["IL"] = "IL";
    USStates["IN"] = "IN";
    USStates["IA"] = "IA";
    USStates["KS"] = "KS";
    USStates["KY"] = "KY";
    USStates["LA"] = "LA";
    USStates["ME"] = "ME";
    USStates["MD"] = "MD";
    USStates["MA"] = "MA";
    USStates["MI"] = "MI";
    USStates["MN"] = "MN";
    USStates["MS"] = "MS";
    USStates["MO"] = "MO";
    USStates["MT"] = "MT";
    USStates["NE"] = "NE";
    USStates["NV"] = "NV";
    USStates["NH"] = "NH";
    USStates["NJ"] = "NJ";
    USStates["NM"] = "NM";
    USStates["NY"] = "NY";
    USStates["NC"] = "NC";
    USStates["ND"] = "ND";
    USStates["OH"] = "OH";
    USStates["OK"] = "OK";
    USStates["OR"] = "OR";
    USStates["PA"] = "PA";
    USStates["RI"] = "RI";
    USStates["SC"] = "SC";
    USStates["SD"] = "SD";
    USStates["TN"] = "TN";
    USStates["TX"] = "TX";
    USStates["UT"] = "UT";
    USStates["VT"] = "VT";
    USStates["VA"] = "VA";
    USStates["WA"] = "WA";
    USStates["WV"] = "WV";
    USStates["WI"] = "WI";
    USStates["WY"] = "WY";
    USStates["DC"] = "DC";
})(USStates || (exports.USStates = USStates = {}));
// Mapping of state abbreviations to full state names for display
exports.StateNames = {
    [USStates.AL]: 'Alabama',
    [USStates.AK]: 'Alaska',
    [USStates.AZ]: 'Arizona',
    [USStates.AR]: 'Arkansas',
    [USStates.CA]: 'California',
    [USStates.CO]: 'Colorado',
    [USStates.CT]: 'Connecticut',
    [USStates.DE]: 'Delaware',
    [USStates.FL]: 'Florida',
    [USStates.GA]: 'Georgia',
    [USStates.HI]: 'Hawaii',
    [USStates.ID]: 'Idaho',
    [USStates.IL]: 'Illinois',
    [USStates.IN]: 'Indiana',
    [USStates.IA]: 'Iowa',
    [USStates.KS]: 'Kansas',
    [USStates.KY]: 'Kentucky',
    [USStates.LA]: 'Louisiana',
    [USStates.ME]: 'Maine',
    [USStates.MD]: 'Maryland',
    [USStates.MA]: 'Massachusetts',
    [USStates.MI]: 'Michigan',
    [USStates.MN]: 'Minnesota',
    [USStates.MS]: 'Mississippi',
    [USStates.MO]: 'Missouri',
    [USStates.MT]: 'Montana',
    [USStates.NE]: 'Nebraska',
    [USStates.NV]: 'Nevada',
    [USStates.NH]: 'New Hampshire',
    [USStates.NJ]: 'New Jersey',
    [USStates.NM]: 'New Mexico',
    [USStates.NY]: 'New York',
    [USStates.NC]: 'North Carolina',
    [USStates.ND]: 'North Dakota',
    [USStates.OH]: 'Ohio',
    [USStates.OK]: 'Oklahoma',
    [USStates.OR]: 'Oregon',
    [USStates.PA]: 'Pennsylvania',
    [USStates.RI]: 'Rhode Island',
    [USStates.SC]: 'South Carolina',
    [USStates.SD]: 'South Dakota',
    [USStates.TN]: 'Tennessee',
    [USStates.TX]: 'Texas',
    [USStates.UT]: 'Utah',
    [USStates.VT]: 'Vermont',
    [USStates.VA]: 'Virginia',
    [USStates.WA]: 'Washington',
    [USStates.WV]: 'West Virginia',
    [USStates.WI]: 'Wisconsin',
    [USStates.WY]: 'Wyoming',
    [USStates.DC]: 'District of Columbia',
};
// Helper function to get state name from abbreviation
const getStateName = (abbreviation) => {
    return exports.StateNames[abbreviation];
};
exports.getStateName = getStateName;
